var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import AddOrganizationModal from './AddOrganizationModal';
import { Grid, TileHeader, Tile, TileComment } from '../common/Tile';
import { ToolbarWithOnClick } from '../common/Toolbar';
import { useRouter } from '../../context/router-context';
import { Body } from '../root/PageRouter';
import Loading from '../common/Loading';
import CenteredSign from '../common/CenteredSign';
import { A } from '../common/Links';
import { useOrganizationsListQuery } from '../../__generated__/graphql';
function Toolbar(props) {
    return (_jsx(ToolbarWithOnClick, __assign({ onClick: props.onClick, "data-test": "my-organizations-toolbar" }, { children: "My Companies" }), void 0));
}
export default function OrganizationsHome() {
    // Helpers
    var goForwardClick = useRouter().goForwardClick;
    // State - modal
    var _a = useState(false), modalIsOpen = _a[0], setModalIsOpen = _a[1];
    // GraphQL query
    var _b = useOrganizationsListQuery(), data = _b.data, loading = _b.loading;
    var organizations = data && data.organizations;
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(Toolbar, {}, void 0),
                _jsx(Loading, {}, void 0)] }, void 0));
    }
    if (!organizations) {
        throw new Error('Organizations query failed');
    }
    if (organizations.length === 0) {
        return (_jsxs(_Fragment, { children: [_jsx(Toolbar, { onClick: function () { return setModalIsOpen(true); } }, void 0),
                _jsx(CenteredSign, { children: _jsx(A, __assign({ onClick: function () { return setModalIsOpen(true); } }, { children: "Create a company" }), void 0) }, void 0),
                _jsx(AddOrganizationModal, { open: modalIsOpen, onCancel: function () { return setModalIsOpen(false); } }, void 0)] }, void 0));
    }
    return (_jsxs(_Fragment, { children: [_jsx(Toolbar, { onClick: function () { return setModalIsOpen(true); } }, void 0),
            _jsx(AddOrganizationModal, { open: modalIsOpen, onCancel: function () { return setModalIsOpen(false); } }, void 0),
            _jsx(Body, { children: _jsx(Grid, { children: organizations.map(function (_a) {
                        var id = _a.id, name = _a.name, description = _a.description;
                        return (_jsxs(Tile, __assign({ onClick: goForwardClick("/organizations/" + id) }, { children: [_jsx(TileHeader, { children: name }, void 0),
                                _jsx(TileComment, { children: description }, void 0)] }), id));
                    }) }, void 0) }, void 0)] }, void 0));
}
//# sourceMappingURL=OrganizationsHome.js.map